import { render, staticRenderFns } from "./IconMark.vue?vue&type=template&id=7e2e10cc&scoped=true&lang=pug&"
import script from "./IconMark.vue?vue&type=script&lang=ts&"
export * from "./IconMark.vue?vue&type=script&lang=ts&"
import style0 from "./IconMark.vue?vue&type=style&index=0&id=7e2e10cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2e10cc",
  null
  
)

export default component.exports